import s from './Stat.module.css';

export default function Stat({ label, value, sub, className = '', ...rest }) {
  return (
    <div className={`${s.stat} ${className}`.trim()} {...rest}>
      <span className={s.label}>{label}</span>
      <span className={s.value}>{value}</span>
      {sub && <span className={s.sub}>{sub}</span>}
    </div>
  );
}
